<div class="Footer_bottom">

  <section class="page-hero-section d-flex flex-column align-items-center justify-content-center">
    <div class="container-fluid">
      <div class="row justify-content-center align-items-center">
        <div class="col-md-6">
          <h1 class="page-hero-title text-center">Introduction to the PRISM</h1>
        </div>
      </div>
    </div>
  </section>

  <div class="container">
    <div class="d-flex align-items-center py-3">
      <svg class="me-2 pointer" (click)="backToForm()" id="keyboard_backspace_black_24dp_3_"
        data-name="keyboard_backspace_black_24dp(3)" xmlns="http://www.w3.org/2000/svg"
        width="24" height="24" viewBox="0 0 24 24">
        <path id="Path_7892" data-name="Path 7892" d="M0,0H24V24H0Z" fill="none"/>
        <path id="Path_7893" data-name="Path 7893" d="M21,11H6.83l3.58-3.59L9,6,3,12l6,6,1.41-1.41L6.83,13H21Z" fill="black"/>
      </svg>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb m-0">
          <li class="breadcrumb-item fs-18 fw-400 pointer" (click)="backToForm()">PRISM</li>
          <li class="breadcrumb-item fs-18 fw-600 active-breadcrumb active">Introduction to the PRISM</li>
        </ol>
      </nav>
    </div>
  </div>

  <section class="para-section">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div *ngIf="introLoading"
            class="prism-intro-loading d-flex justify-content-center py-5"
            aria-busy="true"
            aria-label="Loading PRISM Intro">
            <span class="prism-intro-loader-spinner"></span>
          </div>
          <div *ngIf="!introLoading"
            class="prism-intro-cms cms-content"
            [innerHTML]="introHtml | sanitizeHtml">
          </div>
        </div>
      </div>
    </div>
  </section>

</div>
